import React, { useCallback, useState } from 'react';
import { Form, Stack } from 'react-bootstrap';
import useSearch from '../hooks/useSearch';

function SearchWithin() {
    const { searchQuery, updateSearchParams } = useSearch();
    const [searchWithin, setSearchWithin] = useState('');

    const onSearchWithinSubmit = useCallback((e) => {
        e.preventDefault();
        updateSearchParams({ ...searchQuery,
            q: searchWithin || '' });
        if (searchWithin) {
            setSearchWithin('');
        }
    }, [searchQuery, searchWithin]);

    const handleSearchWithin = useCallback((e) => {
        setSearchWithin(e.target.value);
    }, []);

    return (
        <Form
            onSubmit={onSearchWithinSubmit}
        >
            <Stack
                direction={'horizontal'}
                className={'align-items-start'}
                gap={1}
            >
                <Form.Group
                    className={'display-inline-block'}
                    controlId={'SearchWithin.input'}
                >
                    <Form.Control
                        type={'text'}
                        placeholder={'Search Within'}
                        style={{ borderRadius: 0 }}
                        value={searchWithin}
                        onChange={handleSearchWithin}
                    />
                </Form.Group>
                <button
                    type={'submit'}
                    className={'custom-btn'}
                    style={{ padding: '7px' }}
                >
                    Go
                </button>
            </Stack>
        </Form>
    );
}

export default SearchWithin;